import { UserPermissions } from "core/types/enums/PermissionsEnum";

/**
 * Permissions that grant read access to the Work Orders area.
 * `WorkOrder.View` sees only own work orders; `WorkOrder.View.All` sees all of them.
 * Either one is enough to reach the section, so guards check them with "any of" semantics.
 */
export const WORK_ORDER_VIEW_PERMISSIONS = [
  UserPermissions["WorkOrder.View"],
  UserPermissions["WorkOrder.View.All"],
];
